export const BASIC_FILTERS_WRAPPER_ID = 'basic-filters-wrapper';
